import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=53c65072&scoped=true&"
import script from "./CartModal.vue?vue&type=script&lang=ts&"
export * from "./CartModal.vue?vue&type=script&lang=ts&"
import style0 from "./CartModal.vue?vue&type=style&index=0&id=53c65072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c65072",
  null
  
)

export default component.exports